export class Messages {
    static warningDisclaimer = (insertedAmount: any) => `$${insertedAmount} has been applied to your account. Please allow up to 48 hours for your payment to be reflected in your balance due. Should you have any questions, please contact the store location where you made the payment.`
}

export class ErrorMessages {
    static transactionIsInProgress = (step: any) => `Can't close application, because there transaction is in progress. Step: ${step}.`
}
